module.exports = __webpack_public_path__ + "img/icon-certificate.6a0d4c49.svg";